import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
  z-index: 0;
`;

export default Container;
